<div class="flex flex-row justify-start items-center" matTooltip="{{
     item.cells[fieldDefinition.key] ? (item.cells[fieldDefinition.key].value?.toolTip ?
    item.cells[fieldDefinition.key].value?.toolTip : item.cells[fieldDefinition.key].displayText) : ''
    }}">
  <i class="fa fa-info-circle m-r-8" aria-hidden="true"
     [ngClass]="{' not-mandatory': item.cells[this.fieldDefinition?.key]?.value === 'Advisory', ' mandatory': item.cells[this.fieldDefinition?.key]?.value !== 'Advisory'}"></i>
  <div style="width: calc(136px - 31px)"
       attr.data-cy="{{
     item.cells[fieldDefinition.key] ? (item.cells[fieldDefinition.key].value?.toolTip ?
     item.cells[fieldDefinition.key].value?.toolTip : item.cells[fieldDefinition.key].displayText) : ''
    }}"
       *ngIf="item && item.cells" class="grid-cell-ellipsis"

       [innerHTML]="item.cells[fieldDefinition.key] ?
item.cells[fieldDefinition.key].displayText : ''| sanitizeHtml">
  </div>
</div>


